import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { MatDialogRef } from '@angular/material';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-hotel-dialog',
  templateUrl: './hotel-dialog.component.html',
  styleUrls: ['./hotel-dialog.component.scss']
})
export class HotelDialogComponent implements OnInit {

	hotelsData: any;
	public manageHotelForm: FormGroup;
	private hotelsDataSubscription;

	constructor(
		public dialogRef: MatDialogRef<HotelDialogComponent>,
	    private router: Router,
	    private fb: FormBuilder,
	    private commonService: CommonService
	) { 
		this.hotelsDataSubscription = this.commonService.HotelsData.subscribe((hotelsData:any)=>{
	      this.hotelsData = hotelsData;
	    })
	}

	ngOnInit() {
		this.manageHotelForm = this.fb.group({
			hotel: ['', [Validators.required]]
		});
	}

	/*
	* Seletc Hotel Process
	*/
	selectHotelProcess() {
		this.dialogRef.close(this.manageHotelForm.value);
	}

}
